import React from 'react';

import { Icon28SearchStarsOutline } from '@vkontakte/icons';
import {
  Button,
  FormItem,
  FormLayout,
  Input,
} from '@vkontakte/vkui';

import styles from './index.module.css';
import { FriendLinkFormProps } from './types';

export const FriendLinkForm: React.FC<FriendLinkFormProps> = ({ textInput, onTextInputChange, handleUserSearchButton, error }) => {
  return (
    <div className={styles.informativeContent}>
      <div className={styles.linkContainer}>
        <FormLayout className={styles.formContainer}>
          <FormItem
            top="Ссылка на страницу пользователя"
            status={ error ? 'error' : 'default' }
            bottom={ error }
          >
            <Input
              value={textInput}
              type="text"
              placeholder="Введите ссылку"
              onChange={onTextInputChange}
            />
          </FormItem>
        </FormLayout>
      </div>
      <div className={styles.toFriendButtonOuterContainer}>
        <div className={styles.toFriendButtonInnerContainer}>
          <Button
            mode="tertiary"
            size="m"
            before={<Icon28SearchStarsOutline />}
            stretched
            onClick={handleUserSearchButton}
          >
            Воспользоваться поиском
          </Button>
        </div>
      </div>
    </div>);
};
